import React, { useContext, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { LockOutlined, UserOutlined, HomeOutlined } from "@ant-design/icons";
import { Button, Form, Input, Alert } from "antd";
import { SignedInContext } from "../AppEnv";
import { SignedInDoctor, SignInDoctor } from "./interfaces";
import "./Login.css";
import { adminsignIn, getAdminMe, getMe, signIn } from "./utils";
import {
  ALMSG_ERR_CREDENTIALS,
  ALMSG_INTERNAL_ERR,
  ALMSG_SESS_EXPIRED,
  ALMSG_TIMEOUT,
  HOME_PATH,
  INTERNAL_ERR,
  ADMIN_LOGIN_TOKEN,
  SESS_EXPIRED,
  ADMIN_HOME_PATH,
} from "../env";

const AdminLogin: React.FC = () => {
  const navigate = useNavigate();
  const { setSignedInDoctor } = useContext(SignedInContext);
  const [cookies, setCookie] = useCookies([ADMIN_LOGIN_TOKEN]);
  const [wrongCredentials, setWrongCredentials] = useState(false);

  const search = useLocation().search;
  let sessionExpired: boolean =
    parseInt(new URLSearchParams(search).get(SESS_EXPIRED) || "0") == 1;
  let serverError: boolean =
    parseInt(new URLSearchParams(search).get(INTERNAL_ERR) || "0") == 1;

  const onFinish = async (loginValues: SignInDoctor) => {
    //console.log(loginValues);
    const token = await adminsignIn(loginValues);
    //console.log(token);
    if (token) {
      //console.log("Logged in! Received token for auth: ", token);
      const loggedIn: SignedInDoctor = await getAdminMe(token);
      loggedIn.token = token;
      //console.log("Admin", loggedIn);
      if (setSignedInDoctor) setSignedInDoctor(loggedIn);

      setCookie(ADMIN_LOGIN_TOKEN, token, {
        path: "/",
        expires: new Date(new Date().getTime() + 1000 * 60 * 60 * 2), //expires in 2 hours
      });
      navigate("/app" + ADMIN_HOME_PATH);
    } else {
      //console.log("Wrong credentials!");
      setWrongCredentials(true);
    }
  };

  return (
    <div className="login-page">
      <div className="form">
        <div className="login">
          <div className="login-header">
            <h3>ADMIN LOGIN</h3>
          </div>
        </div>
        <Form
          name="normal_login"
          className="login-form"
          initialValues={{ remember: true }}
          onFinish={onFinish}
        >
          <Form.Item
            name="username"
            rules={[
              {
                required: true,
                message: "Per favore inserisci il tuo username!",
              },
            ]}
          >
            <Input
              prefix={
                <UserOutlined className="site-form-item-icon" rev={undefined} />
              }
              placeholder="Username"
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              { required: true, message: "Per favore inserisci una password!" },
            ]}
          >
            <Input
              prefix={
                <LockOutlined className="site-form-item-icon" rev={undefined} />
              }
              type="password"
              placeholder="Password"
            />
          </Form.Item>
          <Form.Item
            name="studio"
            rules={[
              {
                required: true,
                message:
                  "Qui devi inserire la credenziale relativa al tuo studio!",
              },
            ]}
          >
            <Input
              prefix={
                <HomeOutlined className="site-form-item-icon" rev={undefined} />
              }
              type="text"
              placeholder="Studio"
            />
          </Form.Item>

          <Form.Item>
            {wrongCredentials && (
              <Alert
                message={ALMSG_ERR_CREDENTIALS}
                description=""
                type="error"
                showIcon
              />
            )}
            {sessionExpired && (
              <Alert
                message={ALMSG_SESS_EXPIRED}
                description=""
                type="error"
                showIcon
              />
            )}
            {serverError && (
              <Alert
                message={ALMSG_INTERNAL_ERR}
                description=""
                type="error"
                showIcon
              />
            )}
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
            >
              Log in
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

/*
REMEMBER ME FORM ITEM
<Form.Item>
  <Form.Item name="remember" valuePropName="checked" noStyle>
    <Checkbox>Remember me</Checkbox>
  </Form.Item>
</Form.Item>
*/

export default AdminLogin;
